// @flow
import { connect } from 'react-redux';
import ScribeTranscriptList from './ScribeTranscriptList';

const mapStateToProps = state => {
  const {
    scribeTranscriptUI: { fontSize, correctionMode, electronCaptionMode },
    scribeConversation: {
      furthestObservedCursors,
      lang,
      loaded,
      scribe,
      speakers,
      status,
      transcripts,
      transcriptsCurrent,
      transcriptsFinal,
      recording,
    },
    scribeSession: { captioner, currentPlatform, features, inConferenceCall, audioParamsSent },
  } = state;

  return {
    currentPlatform,
    features,
    fontSize,
    electronCaptionMode,
    furthestObservedCursors,
    lang,
    loaded,
    inConferenceCall,
    scribe,
    correctionMode,
    speakers,
    status,
    transcripts,
    transcriptsCurrent,
    transcriptsFinal,
    user: captioner,
    recording,
    audioParamsSent,
  };
};

export default connect(mapStateToProps)(ScribeTranscriptList);
